(function () {
  function init(root) {
    if (root.dataset.proofReady === 'true') return;
    root.dataset.proofReady = 'true';
    root.querySelectorAll('.listicle-proof__video-card').forEach(function (card) {
      var video = card.querySelector('video');
      var button = card.querySelector('button');
      if (!video || !button) return;
      function sync() { card.classList.toggle('is-playing', !video.paused && !video.ended); }
      button.addEventListener('click', function () {
        if (video.paused || video.ended) {
          root.querySelectorAll('video').forEach(function (other) { if (other !== video) other.pause(); });
          var attempt = video.play();
          if (attempt && attempt.catch) attempt.catch(function () {});
        } else {
          video.pause();
        }
      });
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      video.addEventListener('ended', sync);
    });
  }
  function initAll() { document.querySelectorAll('[data-listicle-proof]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
